/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overwrite_Settings_ConfirmInputs */



/**
* | output |
* | --- |
* | "This will overwrite your current settings. Are you sure you want to continue?" |
*
* @param {Overwrite_Settings_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const overwrite_settings_confirm = /** @type {((inputs?: Overwrite_Settings_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overwrite_Settings_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ceci écrasera vos paramètres actuels. Êtes-vous sûr de vouloir continuer ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dadurch werden Ihre aktuellen Einstellungen überschrieben. Möchten Sie fortfahren?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le impostazioni correnti verranno sovrascritte. Vuoi continuare?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Это перезапишет ваши текущие настройки. Вы уверены, что хотите продолжить?")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esto sobrescribirá tu configuración actual. ¿Estás seguro de que deseas continuar?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("这将覆盖您当前的设置。您确定要继续吗？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("これにより現在の設定が上書きされます。続行してもよろしいですか?")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इससे आपकी मौजूदा सेटिंग्स ओवरराइट हो जाएंगी। क्या आप वाकई जारी रखना चाहते हैं?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Isso irá sobrescrever suas configurações atuais. Tem certeza de que deseja continuar?")
	return /** @type {LocalizedString} */ ("This will overwrite your current settings. Are you sure you want to continue?")
});